import React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableRow} from "@material-ui/core";

export default function KeyValueTable(props) {
    return (<div>
        <TableContainer>
            <Table style={{width: "100%"}} aria-label="custom table">
                <TableBody>
                    {props.rows.map((row) => (
                        <TableRow key={row.name}>
                            <TableCell style={{width: "10%"}}>
                                <label className="mediumText" style={{whiteSpace: "nowrap"}}>
                                    {row.name}
                                </label>
                            </TableCell>
                            <TableCell>
                                <label className="mediumTextBold" style={{color: row.textcolor ? row.textcolor : ""}}>
                                    {row.value}
                                </label>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </div>)
}